import Header from '@propertypal/shared/src/resources/images/pn-devs/fairfields/header.png';
import React, { useMemo } from 'react';
import { useTheme } from 'styled-components';
import { Text, TextProps } from '../../typography';
import DevelopmentContent, { DevelopmentSection } from './DevelopmentContent.pn';
import { DevHeaderImg, DevUnorderdList } from './DevelopmentContent.style.pn';

interface FairfieldsContentProps {}

const FairfieldsContent: React.FC<FairfieldsContentProps> = () => {
  const theme = useTheme();

  const textProps = useMemo(() => {
    const p: TextProps = {
      fontSize: 17,
      lineHeight: 25,
      mt: 8,
      mb: 16,
      color: theme.white,
    };
    return p;
  }, [theme]);

  return (
    <div data-testid="fairfields-content">
      <DevelopmentContent bg="#bc095c">
        <DevelopmentSection narrow>
          <DevHeaderImg src={Header.src} alt="Fairfields Development" />
          <DevUnorderdList {...textProps}>
            <li>
              Show Home Available To View By Private Appointment Through Our South Belfast Office On 028 9066 8888
            </li>
            <li>SPECIFICATION</li>
            <li>KITCHEN</li>
            <li>Choose your luxury Kitchen finishes from our specified range</li>
            <li>Colour choice of worktops</li>
            <li>Appliances to include hob, double oven, extractor, fridge freezer, dishwasher, washer dryer</li>
            <li>Low voltage down lights</li>
            <li>UTILITY ROOM (WHERE APPLICABLE)</li>
            <li>Utility units with choice of door finishes, worktops and handles</li>
            <li>Space for free standing appliances in Utility Room</li>
            <li>SANITARY WARE</li>
            <li>Contemporary white sanitary ware with quality chrome fittings to Bathrooms, Ensuites and WCs</li>
            <li>Low profile shower trays with contemporary glass panels and doors to Bathrooms and Ensuites</li>
            <li>Low voltage down lights</li>
            <li>FLOORING AND TILING</li>
            <li>Soft touch carpet and underlay in Drawing Room, Bedrooms, Stairs and Landing</li>
            <li>Tiled floor to Kitchen, Dine, Garden Room(where applicable), Bathroom, Ensuite, Utility and WC</li>
            <li>Full height tiling to shower enclosures and half height tiling to walls</li>
            <li>HEATING</li>
            <li>Gas fired central heating</li>
            <li>Energy efficient boiler</li>
            <li>Thermostatically controlled high output radiators</li>
            <li>Heated chrome towel rails to Bathroom, Ensuite and WC</li>
            <li>INTERNAL FINISHES</li>
            <li>Painted internal walls in one colour throughout (Quarter Silver emulsion) and white ceilings</li>
            <li>Traditional panel internal doors painted white with quality ironmongery</li>
            <li>Deep moulded skirting boards and architraves</li>
            <li>Newell posts, handrails and spindles painted white</li>
            <li>ELECTRICAL</li>
            <li>Comprehensive range of electrical sockets, switches, TV points and telephone points</li>
            <li>Pre wired for security alarm</li>
            <li>Mains smoke and carbon monoxide detectors</li>
            <li>Pre wired for broadband</li>
            <li>TV points in bedrooms</li>
            <li>Downlighters in Kitchen, Bathroom and Ensuite</li>
            <li>USB charging point per room</li>
            <li>EXTERNAL FINISHES</li>
            <li>Traditional cavity wall construction with roughcast render finish where applicable</li>
            <li>Traditional finish tiled roof</li>
            <li>uPVC double glazed windows</li>
            <li>Georgian GRP front door with 5 point locking system</li>
            <li>Gardens seeded</li>
            <li>Landscaping throughout the development (where applicable)</li>
            <li>Tarmac driveways</li>
            <li>Front and rear outside door lights</li>
            <li>Rear outside water supply</li>
            <li>Paved patio area</li>
          </DevUnorderdList>
          <Text {...textProps}>
            Fairfields is an exclusive development of superbly detailed, luxury homes, situated just off the highly
            sought after Magheralave Road, Lisburn. These homes are an equal footing with some of the finest homes in
            Lisburn and Belfast and will certainly appeal to purchasers who recognise quality. This area has long been
            established as one of the most sought after in Lisburn, offering convenience to many leading grammar and
            primary schools, and is only a few minutes from the city centre with its bustling boutiques, cafes, bars and
            restaurants. Commuting to Belfast could not be easier, via Boomers Way and the M1 motorway which is a few
            minutes drive away. Blue Horizon Developments have invested much time and effort into designing homes which
            are both functional and aesthetically pleasing. These fine homes have the Malone Conservation Area at the
            heart of their design, with a classical elegance and styling, incorporating wonderful heritage colours of
            brick, stone and architectural detailing. Combine this with generous living spaces which meet the needs of
            modern lifestyles and you get homes which are beautiful, both inside and outside. The craftsmanship, thought
            and attention to detail that has gone in to these homes will make them notable for their style and external
            finish, enhancing the beautiful ambience of the area, and providing a timeless, classical look that will
            maintain its appeal for decades.
          </Text>
        </DevelopmentSection>
      </DevelopmentContent>
    </div>
  );
};

export default FairfieldsContent;
